<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('menu.pro_about')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('submenu.task_main')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-3">
            <div class="container">
                <card shadow class="card-profile mt--100 card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-2">
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('task_main.title_main')}}</span></div>
                        </div>
                        <div class="mt-3 py-3 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-12">
                                    <p style="text-align: justify;">{{$t('task_main.title_main_text')}}</p>
                                </div>
                                <a href="https://lex.uz/docs/106197" target="_blank" class="card_div_link">
                                    <span class="card_info_link_info">{{$t('app.law_number')}}</span>
                                    <span class="card_info_link">{{$t('app.bosh_pod')}}</span>
                                    <img src="img/strategy/lex_logo.png" class="image_div_info_link">
                                </a>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section py-1 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-2">
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('task_main.title_main1')}}</span></div>
                        </div>
                        <div class="mt-3 py-3 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-12">
                                    <p style="text-align: justify;" v-html="$t('task_main.title_main1_text')"></p>
                                </div>
                                <a href="https://lex.uz/docs/106197#106232" target="_blank" class="card_div_link">
                                    <span class="card_info_link_info">{{$t('app.law_number')}}</span>
                                    <span class="card_info_link">{{$t('app.bosh_pod')}}</span>
                                    <img src="img/strategy/lex_logo.png" class="image_div_info_link">
                                </a>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section py-1 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-2">
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('task_main.title_main2')}}</span></div>
                        </div>
                        <div class="mt-3 py-3 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-12">
                                    <p style="text-align: justify;" v-html="$t('task_main.title_main2_text')"></p>
                                </div>
                                <a href="https://lex.uz/docs/106197#106251" target="_blank" class="card_div_link">
                                    <span class="card_info_link_info">{{$t('app.law_number')}}</span>
                                    <span class="card_info_link">{{$t('app.bosh_pod')}}</span>
                                    <img src="img/strategy/lex_logo.png" class="image_div_info_link">
                                </a>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
